export default 'M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0';